/*
 * Web-component class : Product size selector.
 */
class ProductSizeSelector extends HTMLElement {
  // Elements

  static productFormButtons = document.querySelector('.product-form__buttons');
  static addToCartBtn = document.querySelector('#add-to-cart__btn');
  static infoSelectors = document.querySelector('.sizeSelector__desktopContainer').querySelector('.infoSelectors');

  // -- size-selector-modal components
  static wrapper = document.querySelector('.sizeSelectorModal__wrapper');
  static sizeSelectorModal = document.querySelector('.sizeSelectorModal');
  static header = document.querySelector('.sizeSelectorModal__header');
  static headerGuideLink = document.querySelector('.sizeSelectorModal__header__guide-link');
  static btnScrollDownWrapper = document.querySelector('.sizeSelectorModal__btnScrollDownWrapper');
  static btnScrollDown = document.querySelector('.sizeSelectorModal__btnScrollDown');
  static content = document.querySelector('.sizeSelectorModal__content');

  // Constants : modal states & sizes

  static isOutOfStock = false;

  // -- size-item constant height (px)
  static modalItemHeight = 60;

  // -- add bottom-offset to (active) modal when using browsers with bottom nav (i.e safari, firefox)
  static initModalOffset__addBrowserOffset = ProductSizeSelector.getMobileOperatingSystem() === 2 ? 55 : 15;

  // -- initial modal offset when active
  static initModalOffset = 115 + ProductSizeSelector.initModalOffset__addBrowserOffset;

  // -- minimum & maximum items to show in a single modal scroll
  static minItems = 5;
  static maxItems = 8;

  // -- calculated modal offset when active: [init-offset] + [items-cumulative-height]
  static modalOffset =
    ProductSizeSelector.initModalOffset +
    ProductSizeSelector.modalItemHeight *
      (ProductSizeSelector.minItems +
        ProductSizeSelector.clamp(
          0,
          sizes.length - ProductSizeSelector.minItems,
          ProductSizeSelector.maxItems - ProductSizeSelector.minItems
        ));

  // -- size-selector-modal state (closed/opened)
  static isModalOpened = false;

  constructor() {
    super();
    // Rendering on mobile device - run size-selector setup for mobile
    if (this.getCurrentComponentType() === 1) {
      this.initMobileSetup();
    }
    // Initial render
    ProductSizeSelector.renderSizeSelector();
  }

  /*
   * Method returns the current component renderer type (desktop/mobile)
   */
  getCurrentComponentType() {
    if (this.id === 'sizeSelectorComponent__desktop') {
      return 0;
    } else {
      return 1;
    }
  }

  /*
   * Method runs the modal setup on mobile devices - assigns events & properties to the dynamic bottom-sheet modal component.
   */
  initMobileSetup() {
    // Assign max height to the mobile size-selector-modal : content component
    ProductSizeSelector.content.style.maxHeight = `${
      ProductSizeSelector.modalItemHeight * ProductSizeSelector.maxItems + 10
    }px`;

    // Creates a new interval that checks (max 4-times) whether size-chart is available or not.
    this.checkSizeChartIntervalIter = 0;
    this.checkSizeChartIntervalId = setInterval(() => {
      // Constants
      const sizeChartDiv = document.getElementById('size-chart');
      const isSizeChartAvailable = getComputedStyle(sizeChartDiv).opacity === '1';

      if (this.checkSizeChartIntervalIter > 3 || isSizeChartAvailable) {
        // Clear interval If size-chart is available or if reached max iterations.
        clearInterval(this.checkSizeChartIntervalId);
        this.checkSizeChartIntervalId = null;
        this.checkSizeChartIntervalIter = 0;
      }
      if (isSizeChartAvailable) {
        // If size-chart is available, show the mobile link version.
        ProductSizeSelector.headerGuideLink.classList.add('show');
      } else {
        ProductSizeSelector.headerGuideLink.classList.remove('show');
      }
      this.checkSizeChartIntervalIter += 1;
    }, 3000);

    // If initial scroll position is top and sizes amount are less than max items in scrollview, show 'scroll-down' button
    if (ProductSizeSelector.content.scrollTop < 1 && sizes.length > ProductSizeSelector.maxItems) {
      ProductSizeSelector.btnScrollDownWrapper.classList.add('show');
    }

    // Assign scroll event to content component - toggle btnScrollDown
    ProductSizeSelector.content.addEventListener('scroll', function (evt) {
      if (ProductSizeSelector.content.scrollTop < 1 && sizes.length > ProductSizeSelector.maxItems) {
        // Scroll position is top (or sizes amount are less than max items in scrollview)
        ProductSizeSelector.btnScrollDownWrapper.classList.add('show');
      } else {
        // Scroll position is below top
        ProductSizeSelector.btnScrollDownWrapper.classList.remove('show');
      }
    });

    // Add click event to size-selector-modal wrapper - closing the modal
    ProductSizeSelector.wrapper.addEventListener('click', function (evt) {
      if (evt.target === ProductSizeSelector.wrapper) {
        ProductSizeSelector.toggleModal(null, false);
      }
    });

    // Assign touch-start event to modal header - disable surrounding scroll
    ProductSizeSelector.header.addEventListener('touchstart', function (evt) {
      ProductSizeSelector.sizeSelectorModal.style.transition = 'none';
      this.startY = evt.touches[0].clientY;
      document.body.classList.add('mobile__hide_scroll');
      ProductSizeSelector.content.style.overflowY = 'hidden';
    });

    // Assign touch-move event to modal header - move modal along with the mouse position
    ProductSizeSelector.header.addEventListener('touchmove', function (evt) {
      evt.stopPropagation();
      this.endY = evt.touches[0].clientY;
      const deltaY = this.endY - this.startY;
      if (deltaY > 0) {
        ProductSizeSelector.sizeSelectorModal.style.transform = `translateY(-${
          ProductSizeSelector.modalOffset + deltaY * -1
        }px)`;
      }
    });

    // Assign touch-end event to modal header - stop mouse-tracking effect and determine modal state & position
    ProductSizeSelector.header.addEventListener('touchend', function () {
      ProductSizeSelector.sizeSelectorModal.style.transition = 'top 0.7s ease';
      const deltaY = this.endY - this.startY;
      if (deltaY > 50) {
        // Close modal
        ProductSizeSelector.toggleModal(null, false);
      } else {
        // No movement - reset to previous position
        ProductSizeSelector.sizeSelectorModal.style.transform = `translateY(- ${ProductSizeSelector.modalOffset}px)`;
      }
      if (!ProductSizeSelector.isModalOpened) {
        // Re-enable body scroll if modal is closed
        document.body.classList.remove('mobile__hide_scroll');
      }
      ProductSizeSelector.content.style.overflowY = 'auto';
    });

    // Assign click event to header guide-link - open size-guide modal
    ProductSizeSelector.headerGuideLink.addEventListener('click', function () {
      // Constants
      const sizeChartDiv = document.getElementById('size-chart');
      if (sizeChartDiv) {
        // ProductSizeSelector.toggleModal(null, false);
        sizeChartDiv.click();
      }
    });

    // Assign click event to btn-scroll-down on mobile scroll
    ProductSizeSelector.btnScrollDown.addEventListener('click', function () {
      // ProductSizeSelector.content.scrollTop = ProductSizeSelector.content.scrollHeight;
      ProductSizeSelector.content.scrollTo({
        top: ProductSizeSelector.content.scrollHeight,
        behavior: 'smooth',
      });
      ProductSizeSelector.btnScrollDownWrapper.classList.add('hide');
    });
  }

  /*
   * (Static) Method returns the given value bounded by the given min-max range
   * @param min - the minimum range value (type: number).
   * @param value - the required value within the range (type: number).
   * @param max - the maximum range value (type: number).
   */
  static clamp(min, value, max) {
    if (value < min) return min;
    else if (value > max) return max;
    return value;
  }

  /*
   * (Static) Method returns the mobile operating system type as enum.
   */
  static getMobileOperatingSystem() {
    // Constants
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent) || /android/i.test(userAgent)) {
      return 1;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 2;
    } else {
      return 1;
    }
  }

  /*
   * (Static) Method returns whether app is in mobile mode.
   */
  static isMobile() {
    return document.body.clientWidth <= 900;
  }

  /*
   * (Static) Method updates the variant param in the URL.
   * @param newVariantId - The updated variant to set as a search parameter.
   */
  static updateUrlVariant(newVariantId) {
    const currentUrl = new URL(window.location.href);
    // Update the variant parameter
    currentUrl.searchParams.set('variant', newVariantId);
    // Replace the current state without refreshing the page
    history.replaceState(null, null, currentUrl.toString());

    document.querySelectorAll('.psku').forEach((element) => {
      element.innerText = 'טוען מק"ט...';
    });

    fetch(currentUrl.toString())
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const fetchedPsku = doc.querySelector('.psku').innerText;
        document.querySelectorAll('.psku').forEach((element) => {
          element.innerText = fetchedPsku;
        });
      });
  }

  /*
   * (Static) Method toggles the size-selector-modal state.
   * @param src - the text to display in the modal title when invoking the function. (type: enum)
   * @param shouldOpen - explicit boolean state to open/close the modal. If not specified, the modal is toggled by itself. (type: boolean [optional])
   */
  static toggleModal(src, shouldOpen) {
    // Adjust modal title text based on src argument
    const modalTitle = document.querySelector('.sizeSelectorModal__header__details').querySelector('h3');

    if (src === 1) {
      modalTitle.textContent = 'הוספת מידה לסל';
    } else if (src === 2) {
      modalTitle.textContent = 'בחרו מידה';
    }

    // Toggle modal
    if (shouldOpen === false || ProductSizeSelector.isModalOpened) {
      // Close modal
      ProductSizeSelector.sizeSelectorModal.style.transform = 'translateY(0)';
      ProductSizeSelector.wrapper.style.backgroundColor = 'transparent';
      ProductSizeSelector.wrapper.style.pointerEvents = 'none';
      setTimeout(() => {
        // Restore to initial props (if animation was not cancelled)
        if (!ProductSizeSelector.isModalOpened) {
          document.body.classList.remove('mobile__hide_scroll');
          ProductSizeSelector.wrapper.style.opacity = '0';
        }
      }, 900);
      // Update flag
      ProductSizeSelector.isModalOpened = shouldOpen ?? false;
    } else {
      // Open modal
      ProductSizeSelector.wrapper.style.opacity = '1';
      ProductSizeSelector.sizeSelectorModal.style.transition = 'top 0.7s ease';
      ProductSizeSelector.sizeSelectorModal.style.transform = `translateY(-${ProductSizeSelector.modalOffset}px)`;
      // Enable body scroll
      document.body.classList.add('mobile__hide_scroll');
      // Hide modal wrapper
      ProductSizeSelector.wrapper.style.pointerEvents = 'visible';
      ProductSizeSelector.wrapper.style.backgroundColor = '#0005';
      // Update flag
      ProductSizeSelector.isModalOpened = shouldOpen ?? true;
    }
  }

  /*
   * (Static) Method closes the size-selector modal & opens the restock-rocket modal.
   */
  static openRestockRocketModal() {
    document.querySelector('.restock-rocket-button-cover')?.click();
    ProductSizeSelector.toggleModal(null, false);
  }

  /*
   * (Static) Method renders the size-selector layout in both mobile (interactive modal form) and desktop (static body form) modes.
   */
  static renderSizeSelector(triggeredByEvent = false) {
    // Size-selector container variants for dynamic items rendering
    const sizeSelector__desktop = document.querySelector('.sizeSelector');
    const sizeSelector__mobile = document.querySelector('.sizeSelectorModal__sizeSelector');

    // Clear size-selector containers
    sizeSelector__mobile.innerHTML = '';
    sizeSelector__desktop.innerHTML = '';

    let noSizes = sizes.length === 0;
    let oneSize = sizes.length === 1 && sizes[0].size === 'OS';

    if (noSizes || oneSize) {
      ProductSizeSelector.productFormButtons.classList.add('no-sizes');
    }

    if (noSizes) return;

    if (oneSize) {
      selectedSize = sizes[0];
    } else {
      // More than one size exists - show (desktop version) sizes
      document.querySelector('.sizeSelector__desktopContainer').style.display = 'flex';
    }

    // Create a hidden size input
    var sizeInputEl = document.createElement('input');
    sizeInputEl.setAttribute('type', 'hidden');
    sizeInputEl.setAttribute('id', 'sizeInput');
    sizeInputEl.setAttribute('value', '');
    sizeInputEl.setAttribute('name', 'options[size]');
    sizeInputEl.setAttribute('form', product_form_id);

    // Iterate through sizes array and create item elements
    const productsByAvailability = sizes.map((sizeObj) => {
      // Constants
      const productId = variantsData.find((vdata) => vdata.option2 == sizeObj.size)?.id;
      const stockQuantity = stockData[productId];
      const productQuantity = productsQuantity[productId];
      const isProductAvailable = sizeObj.available && (stockQuantity > 0 || isNaN(stockQuantity));
      const isProductInCart = productQuantity && productQuantity > 0;

      // Elements of info-selectors container
      const infoSelectors__elements = `
            <span class="info__amountInCart" style="display:${productQuantity ? 'inline' : 'none'};">
              קיים בסל (${productQuantity})
            </span>
            <span class="info__avaliableItems" style="display:${
              (stockQuantity >= 1 && stockQuantity <= 3) || (isProductAvailable && isNaN(stockQuantity))
                ? 'flex'
                : 'none'
            };">
              <img src="${sizeSelector__icon_clock}" />
              <span>${
                stockQuantity === 1 || isNaN(stockQuantity) ? 'פריט אחרון במלאי' : `נותרו (${stockQuantity}) פריטים`
              }</span>
            </span>
            <span class="info__linkNotifyMe" style="display:${isProductAvailable ? 'none' : 'flex'};">
              <img class="icon_desktop" src="${sizeSelector__icon_bell}" />
              <img class="icon_mobile" src="${sizeSelector__icon_email}" />
              <span>עדכנו אותי</span>
            </span>
          `;

      // Item root element
      const item__element = `
            <div class="sizeSelector__item ${!isProductAvailable ? 'unavaliable' : ''}">
              <span class="sizeSelector__overlayClick"></span>
              <div class="sizeSelector__extraSection"></div>
              <button class="sizeSelector__btn ${
                sizeObj === selectedSize ? 'sizeSelector__btn-active' : ''
              }" id="${buttonElement__option_attribute}">
                <span>${sizeObj.size}</span>
                <div class="dLine">&nbsp;</div>
              </button>
              <div class="sizeSelector__infoSection ${isProductInCart ? 'product-in-cart' : ''}">
                ${infoSelectors__elements}
              </div>
            </div>
          `;

      // Clear info-selectors & render as string in header (if desktop mode)
      if (selectedSize !== null && sizeObj?.size === selectedSize?.size && isProductAvailable) {
        ProductSizeSelector.infoSelectors.innerHTML = infoSelectors__elements;
      }

      // Create a click-event handler for the item
      function onItemClick(evt) {
        // Constants
        const clickedBtn = event.currentTarget.parentNode.querySelector('.sizeSelector__btn');
        // Remove any error highlightings from size-selector form container
        document.querySelector('.sizeSelector__desktopContainer').classList.remove('err__noSizeChosen');

        // Remove 'active' state from any other item
        document.querySelectorAll('.sizeSelector__btn').forEach((button) => {
          button.classList.remove('sizeSelector__btn-active');
        });

        // Temporarily replace item button text with 'SOLD OUT' when clicked on an unavaliable item
        if (!isProductAvailable) {
          ProductSizeSelector.openRestockRocketModal();
          clickedBtn.querySelector('span').textContent = 'SOLD OUT';
          clickedBtn.style.fontSize = '9px';
          setTimeout(() => {
            clickedBtn.querySelector('span').textContent = sizeObj.size;
            clickedBtn.style.fontSize = '16px';
          }, 1300);
        }

        if (sizeObj?.size !== selectedSize?.size && isProductAvailable) {
          // Highlight active item button
          selectedSize = sizeObj;
          clickedBtn.classList.add('sizeSelector__btn-active');
          // Append selectors into the infoSelectors container
          ProductSizeSelector.infoSelectors.innerHTML = infoSelectors__elements;
          if (ProductSizeSelector.isMobile()) {
            // Collapse modal in mobile mode
            ProductSizeSelector.addToCartBtn.click();
            ProductSizeSelector.toggleModal(null, false);
            selectedSize = null;
          }
          ProductSizeSelector.updateUrlVariant(productId);
        } else {
          selectedSize = null;
          ProductSizeSelector.infoSelectors.innerHTML = '';
          clickedBtn.blur();
        }
      }

      // Create a click-event for the item : notify-me link
      function onClick__notifyMe(e) {
        e.stopPropagation();
        ProductSizeSelector.openRestockRocketModal();
      }

      // -- convert the item__element component to a DOM element.
      // -- tl;dr - the re-assignment of the click-event handler to the cloned item fixes the issue where
      // -- cloned items don't copy click events by default.
      const itemComponent__mobile = new DOMParser().parseFromString(item__element, 'text/html').body.firstChild;
      const itemComponent__desktop = itemComponent__mobile.cloneNode(true);

      // -- assign click-handler to desktop-variant item; append code into desktop sizeSelector element
      itemComponent__desktop.querySelector('.info__linkNotifyMe').addEventListener('click', onClick__notifyMe);
      itemComponent__desktop.querySelector('.sizeSelector__overlayClick')?.addEventListener('click', onItemClick);

      // Re-assign click-handler to mobile-variant item; append code into mobile sizeSelector element.
      itemComponent__mobile.querySelector('.info__linkNotifyMe').addEventListener('click', onClick__notifyMe);
      itemComponent__mobile.querySelector('.sizeSelector__overlayClick')?.addEventListener('click', onItemClick);

      sizeSelector__desktop.appendChild(itemComponent__desktop);
      sizeSelector__mobile.appendChild(itemComponent__mobile);

      sizeSelector__desktop.appendChild(sizeInputEl);
      sizeSelector__mobile.appendChild(sizeInputEl.cloneNode(true));

      // Return avaliable product
      return isProductAvailable;
    });

    // If no product is avaliable in stock, turn add-to-cart-btn into notify-me-overlay-btn
    if (!productsByAvailability.some((p) => p === true)) {
      setTimeout(
        () => {
          // If triggered by event, delay the overlay-notify-me fade-in
          ProductSizeSelector.isOutOfStock = true;
          ProductSizeSelector.productFormButtons.classList.add('out-of-stock');
        },
        triggeredByEvent ? 2500 : 0
      );
    } else {
      ProductSizeSelector.isOutOfStock = false;
      ProductSizeSelector.productFormButtons.classList.remove('out-of-stock');
    }

    // If no product is avaliable in stock, turn add-to-cart-btn into notify-me-overlay-btn
    if (!productsByAvailability.some((p) => p === true)) {
      setTimeout(
        () => {
          // If triggered by event, delay the overlay-notify-me fade-in
          ProductSizeSelector.isOutOfStock = true;
          ProductSizeSelector.productFormButtons.classList.add('out-of-stock');
        },
        triggeredByEvent ? 2500 : 0
      );
    } else {
      ProductSizeSelector.isOutOfStock = false;
      ProductSizeSelector.productFormButtons.classList.remove('out-of-stock');
    }
  }
}

// Define custom web component : product-size-selector
if (!customElements.get('product-size-selector')) {
  customElements.define('product-size-selector', ProductSizeSelector);
}
